import { Component, OnInit } from '@angular/core';
import { ConfirmationDialogsService } from './confirmation-dialog.service';

@Component({
    selector: 'confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent implements OnInit {
    constructor(
        public confirmationDialogsService: ConfirmationDialogsService
    ) { }

    public title: string;
    public message: string;
    public titleAlign?: string;
    public messageAlign?: string;
    public btnOkText: string = "";
    public btnCancelText: string = "";

    ngOnInit() {
    }

}
